import { tw } from "../../styling";

type Props = {
	children: React.ReactNode;
};

const classes = tw`ml-8 pb-8`;

const StepContent = ({ children }: Props) => <section className={classes}>{children}</section>;

export default StepContent;
